// extracted by mini-css-extract-plugin
module.exports = {"payment-summary-container":"_2_unApIVbFiFiR6UWdAsHf","summary-price":"_2wQcPjIKzJx-92M1pD0sFU","summary-month":"_1mKfQwFND3lo92hTDvbqB0"};